import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
  center?: boolean;
}

export default function SectionHeading({ eyebrow, title, desc, action, center = false }: SectionHeadingProps) {
  return (
    <div
      className={`flex flex-col gap-4 mb-7 md:mb-9 ${
        center ? "items-center text-center" : "sm:flex-row sm:items-end sm:justify-between"
      }`}
    >
      <div className={center ? "max-w-2xl" : "max-w-2xl"}>
        {eyebrow && (
          <div className={`flex items-center gap-2 mb-2 ${center ? "justify-center" : ""}`}>
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            <span className="text-xs font-semibold tracking-[0.18em] text-accent-600 uppercase">{eyebrow}</span>
          </div>
        )}
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-tight">{title}</h2>
        {desc && <p className="mt-3 text-sm md:text-[15px] leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
}